/**
 * Programas de milhas mockados.
 * Saldo é fictício; custo vem de VITE_MILES_COST (default 1200).
 */

export type MilesProgramId = 'smiles' | 'tudoazul' | 'latampass';

export type MilesProgram = {
  id: MilesProgramId;
  name: string;
  balance: number;
};

export const MILES_PROGRAMS: readonly MilesProgram[] = [
  { id: 'smiles', name: 'Smiles', balance: 8500 },
  { id: 'tudoazul', name: 'TudoAzul', balance: 5200 },
  { id: 'latampass', name: 'Latam Pass', balance: 12300 },
] as const;

const MILES_FORMATTER = new Intl.NumberFormat('pt-BR');

export function formatMiles(n: number): string {
  return MILES_FORMATTER.format(Math.round(n));
}
